import { useTranslation } from 'react-i18next'

import { ProfileInfoWidget } from '../../../Widget'

import { FINANCIAL_DETAILS_FIELDS } from './UserProfileWidgetFinancialDetails.constants'

function UserProfileWidgetFinancialDetails({
  canEdit,
  data,
  isSkeleton,
  options,
  onSubmit,
}) {
  const { t } = useTranslation()

  return (
    <ProfileInfoWidget
      canEdit={canEdit}
      config={FINANCIAL_DETAILS_FIELDS}
      data={data}
      isSkeleton={isSkeleton}
      options={options}
      title={t('Widget.FinancialDetailsTitleKey')}
      onSubmit={onSubmit}
    />
  )
}

export default UserProfileWidgetFinancialDetails
